var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab-item",class:_vm.selectedTab == 'users' ? 'active' : '',on:{"click":function($event){return _vm.handleTab('users')}}},[_c('span',[_vm._v("Usuários")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }